import { ConfigurationPreformattedResponse } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.dto'
import { ConfigurationOntology } from '@/modules/configurationModule/shared/components/configuration-ontologies/configuration-ontologies.model'
import { Nullable } from '@/shared/types/app.types'
import { uniqueId } from 'lodash'

export enum LocalPreformattedModalTabIndex {
    FORM_DATA = 0,
    ONTOLOGIES = 1,
    MACRO = 2,
    MICRO = 3,
    DIAGNOSE = 4,
    ADDITIONAL_REPORT = 5,
    CODIFICATIONS = 6
}

export interface ConfigurationOntologyPreformattedTemplate extends ConfigurationOntology {
    preformattedId: number
}

export interface LocalPreformattedModalState {
    ontologies: ConfigurationOntologyPreformattedTemplate[]
    activeTabIndex: LocalPreformattedModalTabIndex
    modalUID: string
    selectedRow: Nullable<ConfigurationPreformattedResponse>
}
export const initialLocalPreformattedModalState =
    (): LocalPreformattedModalState => ({
        ontologies: [],
        activeTabIndex: LocalPreformattedModalTabIndex.FORM_DATA,
        selectedRow: null,
        modalUID: uniqueId()
    })
